<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="536">
    <v-row class="pr-8 pt-9 pl-9 white">
      <v-col cols="12">
        <p class="primary--text font-weight-bold mb-2">
          COTAÇÃO SOLICITADA
        </p>
      </v-col>
      <v-col cols="12">
        <p class="primary--text font-weight-medium mb-0">
          A cotação foi solicitada com sucesso.
        </p>
        <p class="font-weight-medium primary--text mb-10">
          Deseja realizar uma nova cotação?
        </p>
      </v-col>
    </v-row>
    <v-row class="pb-6 pr-8 pl-9 white">
      <v-spacer />
      <v-col cols="6" sm="3" class="pr-5">
        <BaseButton
          v-html="'NÃO'"
          color="secondary"
          outlined
          width="100%"
          @click="closeModal(false)"
        />
      </v-col>
      <v-col cols="6" sm="3">
        <BaseButton
          v-html="'SIM'"
          class="secondary"
          width="100%"
          @click="closeModal(true)"
        />
      </v-col>
    </v-row>
  </v-dialog>
</template>
<script>
export default {
  methods: {
    closeModal(value) {
      this.$emit("close", value);
    }
  }
};
</script>
<style lang="sass"></style>
